var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBtc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_101_1185)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M90 45C90 53.9002 87.3608 62.6005 82.4162 70.0007C77.4715 77.4009 70.4435 83.1686 62.2208 86.5746C53.9981 89.9805 44.9501 90.8717 36.221 89.1353C27.4918 87.399 19.4736 83.1132 13.1802 76.8198C6.88685 70.5264 2.60102 62.5082 0.864683 53.7791C-0.871652 45.0499 0.0194976 36.0019 3.42544 27.7792C6.83139 19.5566 12.5991 12.5285 19.9994 7.58387C27.3996 2.6392 36.0999 0 45 0C56.9348 0 68.3807 4.74106 76.8198 13.1802C85.259 21.6193 90 33.0653 90 45Z",
    fill: "#F7931A"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.9827 20.5485L42.3245 23.3181L44.6359 14.7026L49.8068 16.1058L47.5854 24.3654L51.8032 25.4985L54.0286 17.149L59.2895 18.5563L57.0232 26.9508C57.0232 26.9508 65.6141 28.8531 67.635 35.8404C69.6559 42.8276 63.1923 46.4972 61.1959 46.6363C61.1959 46.6363 68.7232 50.764 66.1377 58.8845C63.5523 67.0049 55.6159 68.4572 47.2664 66.5958L45 75.3013L39.7391 73.894L42.0504 65.3235L37.8777 64.1863L35.5664 72.8181L30.3464 71.4149L32.6618 62.824L22.0459 59.9604L24.7214 54.0204C24.7214 54.0204 27.7159 54.8386 28.8491 55.1086C29.9823 55.3786 30.7104 54.2004 31.0295 53.0222C31.3486 51.844 36.1554 32.3181 36.6095 30.7104C37.0636 29.1026 36.8795 27.8467 34.9732 27.3517C33.0668 26.8567 30.4732 26.0835 30.4732 26.0835L31.9827 20.5485ZM42.4145 46.4072L39.5509 57.7922C39.5509 57.7922 53.7504 62.9181 55.5668 55.7058C57.3832 48.4935 42.4145 46.4072 42.4145 46.4072ZM43.7318 41.0072L46.5423 30.5754C46.5423 30.5754 58.7004 32.7517 57.2032 38.5567C55.7059 44.3617 48.5386 42.1363 43.7318 41.0072Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_101_1185"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtc);
export default __webpack_public_path__ + "static/media/btc.ca0b93740703bd7a8d1175b9da2ed075.svg";
export { ForwardRef as ReactComponent };